import React , { useState, useEffect, useContext }  from 'react';
import {typeEngraving, typePattern, typeAccessory} from './Fabric';
import * as _ from 'lodash';
import {getPatternSize} from './../../../services/patterns.service';
import {canDuplicate} from '../../../services/restrictedConfiguration';
import { isConfigRequested } from '../../../services/configurationWarningChecks';
import { TranslationContext } from "../../../context/TranslationContext";

export function FabricFooter({
  configuration, family, patterns, accessories, selectedObjects, onRemoveObjects, onDuplicateObject,
  onMirrorPattern, onChangePattern, onToggleEngravingReservation, onChangeEngravingText, onChangeAccessoryGranite
}) {
  const t = useContext(TranslationContext);

  const colorNames = {
    '#ffdf46': (!family ? (t("config3d_patternandengravings_modal_color_gold") || 'Dorées') : 'Dorées'),
    '#ffffff': (!family ? (t("config3d_patternandengravings_modal_color_white") || 'Blanches'): 'Blanches'),
    '#000000': (!family ? (t("config3d_patternandengravings_modal_color_black") || 'Noires') : 'Noires'),
  };
  if (!selectedObjects || !selectedObjects.length) {
    return null;
  }

  let description;
  let buttons = [];
  let disabled = isConfigRequested();
  let classDisabled = disabled ? "disabled" : "";

  if (selectedObjects.length > 1) {
    buttons.push((
      <button key="remove" onClick={onRemoveObjects} className={classDisabled} disabled={disabled}>Supprimer les éléments sélectionnés</button>
    ));
  } else {
    const selected = selectedObjects[0];

    buttons.push((
      <button 
        key="remove" 
        onClick={() => onRemoveObjects()} 
        className={`${classDisabled} button-small button-secondary text-dark`} 
        disabled={disabled}>
        <span>{!family ? (t("config3d_patternandengravings_delete") || "Supprimer") : "Supprimer"}</span>
        <span className="trash-icon icon-medium text-dark-icon"></span>
      </button>
    ));
    {canDuplicate(configuration,selected.type) && buttons.push((
      <button 
        key="duplicate" 
        onClick={() => onDuplicateObject()} 
        className={`${classDisabled} button-small button-secondary text-dark`}
        disabled={disabled}>
        <span>{!family ? (t("config3d_patternandengravings_duplicate") || "Dupliquer") : "Dupliquer"}</span>
        <span className="plus-icon icon-medium text-dark-icon"></span>
      </button>
    ));}

    switch (selected.type) {
      case typePattern:
        const pattern = _.find(patterns, {reference: selected.reference});
        if (pattern)
        {
          const patternconfig = _.find(configuration.patterns, {id: selected.id});
          const patternSize = getPatternSize(patternconfig,pattern);

          description = (
            <div className="Pattern">
              <h1>
                <span className="Name">{pattern.reference}</span>
                <small className="Kind">{pattern.kind}</small>
                {patternSize && <span className ="PatternSize">{`H: ${patternSize.height} cm | L: ${patternSize.width} cm`}</span>}
              </h1>
              <p className="Description">{pattern.description}</p>
            </div>
          );

          buttons.push((
            <button 
              key="mirror" 
              onClick={() => onMirrorPattern()} 
              className={`${classDisabled} button-small button-secondary text-dark`}
              disabled={disabled}>
              <span>Miroir</span>
              <span className="mirror-left-icon icon-medium text-dark-icon"></span>
            </button>
          ));
        }
        // On le retire mais on garde le code au cas où. La fonctionnalité était tout de même pratique.
        // buttons.push((
        //   <button key="changePattern" onClick={onChangePattern} className="EditPattern">
        //     Modifier le motif
        //     <i className="icon material-icons">&#xE545;</i>
        //   </button>
        // ));
        break;

      case typeEngraving:
        const engraving = _.find(configuration.engravings, {id: selected.id});

        if (engraving.reservation) {
          description = (
            <div className="Engraving">
              <h1>
                <small className="Kind">{!family ? (t("config3d_patternandengravings_reserve_engraving_desc") || "Réserve de gravure") : "Réserve de gravure"}</small>
              </h1>
              <p className="Text">{selected.text}</p>
            </div>
          );
          buttons.push((
            <button 
              key="toggleReservation" 
              onClick={() => onToggleEngravingReservation()} 
              className={`${classDisabled} button-small button-secondary text-dark`} 
              disabled={disabled}>
              <span>{!family ? (t("config3d_patternandengravings_button_to_engraving") || "Basculer en gravure") : "Basculer en gravure"}</span>
              <span className="reservation-on-icon icon-medium text-dark-icon"></span>
            </button>
          ));
        } else {
          const engravingtype = {"Sablées":"sanded","Gravées Main":"hand-engraved"}
          description = (
            <div className="Engraving">
              <h1>
                <small className="Kind">{!family ? (t("config3d_patternandengravings_letters") || "Lettres") : "Lettres"} {t("config3d_patternandengravings_modal_engravings_type_"+engravingtype[engraving.font.kind]) || engraving.font.kind} { t("config3d_patternandengravings_modal_engravings_color_"+engraving.font.color.replace(/#/g, '')) || colorNames[engraving.font.color]} {" "}
                  {!family ? (t("config3d_patternandengravings_on_polish") || "sur poli") : "sur poli"}, {engraving.font.family} {engraving.font.size}mm
                </small>
              </h1>
              <p className="Text">{selected.text}</p>
            </div>
          );
          buttons.push((
            <button key="toggleReservation" 
              onClick={() => onToggleEngravingReservation()} 
              className={`${classDisabled} button-small button-secondary text-dark`} 
              disabled={disabled}>
              <span>{!family ? (t("config3d_patternandengravings_button_to_reservation_engraving") || "Basculer en réserve de gravure") : "Basculer en réserve de gravure"}</span>
              <span className="reservation-off-icon icon-medium text-dark-icon"></span>
            </button>
          ));
        }
        // buttons.push((
        //   <button className="EditText" key="changeEngravingText" onClick={onChangeEngravingText}>
        //     Modifier le texte
        //     <i className="icon material-icons">&#xE254;</i>
        //   </button>
        // ));
        break;

      case typeAccessory:
        const accessory = selected && _.find(accessories, {reference: selected.reference});

        description = accessory && (
            <div className="Accessory">
              <h1>
                <span className="Reference">{accessory.reference}</span>
                <small className="Kind">{accessory.kind}</small>
              </h1>
              <p className="Description">{accessory.description}</p>
            </div>
          );

        buttons.push((
          <button 
            key="granite" 
            onClick={onChangeAccessoryGranite} 
            className={`${classDisabled} button-small button-primary text-cta`}
            disabled={disabled}>
            <span>Modifier le granit</span>
            <span className="granite-icon icon-medium text-cta-icon"></span>
          </button>
        ));
        break;
        default:
            break;        
    }
  }

  return (
    <div className="Footer">
      <div className="Infos">
        {description}
      </div>
      <div className="Actions">
        {buttons}
      </div>
    </div>
  );
}
